import {getAllDataDict} from "@/api/dict";
import {getHomeData} from "@/api/home";
import {formatDateAndTime, formatTime} from "@/utils/dateFun";

const state = {
  banner:[],// Banner 轮播图。✅
notice: [],//通知公告。最近 8 条 ✅
total_device: 0,//设备总数。 ✅
total_device_usage: 0,//设备使用时长 ✅
total_result: 0,//成果总数 ✅
total_demand: 0,//需求总数 ✅
  device_count_in_use: 0,//设备在用数量 （设备状态模块）✅
device_dist: [],//设备分布。每个机构独立统计数量。共 8 个。✅
hot_result: [],//热门成果，按照浏览量来排序 ✅
latest_demand: [],//最新需求 8 条. ✅
appointment: [],//预约信息。最近的 5 条。需要是通过审核的。✅ 设备名称 Device.Name, 预约开始时间 StartTime, 累计预约次数 Device.TotalAppointment
device_top_by_appointment: [],//设备排行 top 10。按照预约次数排序。✅ TotalAppointment
device_top_by_usage: [],//设备排行 top 10。按照使用时长排序。✅ TotalTime
// 设备使用时段分布//。独立的接口比较好。暂未提供，先前端写死吧
// 设备使用趋势//。独立的接口比较好. 暂未提供，先前端写死吧
}
const getters = {
  getBanner: (state) => state.banner,
}
const mutations = {

}
function getCountArr(arr,count){
  if(Array.isArray(arr)){
    const data =  arr.splice(0, count);
    data.forEach(item=>{
     if(item.CreatedAt){
       item.date = formatDateAndTime(item.CreatedAt)[0]
     }
     if(item.StartTime){ // 主要处理预约的时间
       item.StartTimeDeal = formatTime(item.StartTime)
     }
    })
    return data
  }else{
    return []
  }
}
const actions = {
  async getHomeData(context){
    const res = await getHomeData()
    if(res.err_code===0){
      if(res.data){
      context.state.banner =  getCountArr(res.data.banner,8)
      context.state.notice = getCountArr(res.data.notice,8)
      context.state.total_device =  res.data.total_device || 0
      context.state.total_device_usage =  res.data.total_device_usage || 0
      context.state.total_result =  res.data.total_result || 0
      context.state.total_demand =  res.data.total_demand || 0
      context.state.device_count_in_use =  res.data.device_count_in_use || 0
      context.state.device_dist = getCountArr(res.data.device_dist,8)
      context.state.hot_result = getCountArr(res.data.hot_result,8)
      context.state.latest_demand = getCountArr(res.data.latest_demand,8)
      context.state.appointment = getCountArr(res.data.appointment,5)
      context.state.device_top_by_appointment = getCountArr(res.data.device_top_by_appointment,8)
      context.state.device_top_by_usage = getCountArr(res.data.device_top_by_usage,8)
      }
    }
    return Promise.resolve(res)
  }

}
const modules = {}
export default {
  namespaced: true,
  state() {
    return state
  },
  getters,
  mutations,
  actions,
  modules
}

